module.exports = __webpack_public_path__ + "img/partner15.b6cfa1c6.png";